/**
 * @desc 月度库存分页查询
 */
const URL = "/rantion-plat-data-flow";
import http, { updateResponse } from "@/http";
export function request(
  params: API.platDataFlow.reportPage.inventoryMonthlyPage.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/reportPage/inventoryMonthlyPage`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
